import { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";

export default function TimePicker24Field({
  label,
  value,
  onChange,
  disabled,
  fullWidth = true,
  size,
  placeholder,
  textFieldProps = {},
  onAccept,
  onClose,
  ...pickerProps
}) {
  const [open, setOpen] = useState(false);
  const [draftValue, setDraftValue] = useState(value);
  const committedOnCloseRef = useRef(false);

  useEffect(() => {
    if (!open) setDraftValue(value);
  }, [open, value]);

  const commitValue = (nextValue) => {
    committedOnCloseRef.current = true;
    onAccept?.(nextValue);
    onChange?.(nextValue);
  };

  const openPicker = () => {
    if (!disabled) {
      committedOnCloseRef.current = false;
      setDraftValue(value);
      setOpen(true);
    }
  };

  return (
    <TimePicker
      label={label}
      value={open ? draftValue : value}
      onChange={(nextValue) => setDraftValue(nextValue)}
      ampm={false}
      inputFormat="HH:mm"
      mask="__:__"
      disabled={disabled}
      open={open}
      onOpen={openPicker}
      onAccept={(nextValue) => {
        commitValue(nextValue ?? draftValue);
      }}
      {...pickerProps}
      onClose={() => {
        if (!committedOnCloseRef.current) {
          commitValue(draftValue);
        }
        setOpen(false);
        onClose?.();
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          fullWidth={textFieldProps.fullWidth ?? fullWidth}
          size={textFieldProps.size ?? size}
          placeholder={placeholder ?? textFieldProps.placeholder}
          onClick={(event) => {
            textFieldProps.onClick?.(event);
            openPicker();
          }}
          onFocus={(event) => {
            textFieldProps.onFocus?.(event);
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            shrink: true,
            ...textFieldProps.InputLabelProps,
          }}
          inputProps={{
            ...params.inputProps,
            readOnly: true,
            autoComplete: "off",
            "aria-autocomplete": "none",
            ...textFieldProps.inputProps,
          }}
          InputProps={{
            ...params.InputProps,
            autoComplete: "off",
            ...textFieldProps.InputProps,
          }}
        />
      )}
    />
  );
}
